/**
 * useContributionStatus Composable
 *
 * Provides contribution payment status for individual members.
 * - hasUnpaidContribution: member has a negative contribution balance (< 0)
 * - isAfterGracePeriod: current date is past March 31st of the current year
 * - hasExpiredMembership: member is unpaid AND grace period has ended (only for individual members)
 */
export function useContributionStatus() {
  const { membershipContribution, isIndividuel, userType, userStatus } = useAuthData()

  const isMember = computed(() => userType.value === 'membre' && userStatus.value === 'admis')

  const hasUnpaidContribution = computed(() => {
    if (!isIndividuel.value || !isMember.value) return false
    return membershipContribution.value != null && membershipContribution.value < 0
  })

  const isAfterGracePeriod = computed(() => {
    const dayjs = useDayjs()
    return dayjs().isAfter(dayjs().month(2).date(31), 'day') // March 31st
  })

  const hasExpiredMembership = computed(() => {
    return hasUnpaidContribution.value && isAfterGracePeriod.value
  })

  return {
    hasUnpaidContribution,
    isAfterGracePeriod,
    hasExpiredMembership
  }
}
